export default __webpack_public_path__ + "static/media/mars.a15e08e1.svg";